"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMockTraderSettings = void 0;
var getMockTraderSettings = function getMockTraderSettings() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _properties$addInvoic = properties.addInvoiceAsEventOnAutoMatch,
    addInvoiceAsEventOnAutoMatch = _properties$addInvoic === void 0 ? false : _properties$addInvoic,
    _properties$angularUI = properties.angularUISettings,
    angularUISettings = _properties$angularUI === void 0 ? {} : _properties$angularUI,
    _properties$autoMatch = properties.autoMatch,
    autoMatch = _properties$autoMatch === void 0 ? false : _properties$autoMatch,
    _properties$cards = properties.cards,
    cards = _properties$cards === void 0 ? [] : _properties$cards,
    _properties$companyCa = properties.companyCards,
    companyCards = _properties$companyCa === void 0 ? [] : _properties$companyCa,
    _properties$createCus = properties.createCustomerTraderId,
    createCustomerTraderId = _properties$createCus === void 0 ? false : _properties$createCus,
    _properties$createOrd = properties.createOrderForAllInvoices,
    createOrderForAllInvoices = _properties$createOrd === void 0 ? false : _properties$createOrd,
    _properties$customerT = properties.customerTraderIdCharacters,
    customerTraderIdCharacters = _properties$customerT === void 0 ? 8 : _properties$customerT,
    _properties$invoiceNu = properties.invoiceNumberMandatory,
    invoiceNumberMandatory = _properties$invoiceNu === void 0 ? false : _properties$invoiceNu,
    _properties$supplierA = properties.supplierApprovalsEnabled,
    supplierApprovalsEnabled = _properties$supplierA === void 0 ? false : _properties$supplierA;
  return {
    addInvoiceAsEventOnAutoMatch: addInvoiceAsEventOnAutoMatch,
    autoMatch: autoMatch,
    cards: cards,
    companyCards: companyCards,
    createCustomerTraderId: createCustomerTraderId,
    createOrderForAllInvoices: createOrderForAllInvoices,
    customerTraderIdCharacters: customerTraderIdCharacters,
    invoiceNumberMandatory: invoiceNumberMandatory,
    supplierApprovalsEnabled: supplierApprovalsEnabled,
    angularUISettings: angularUISettings
  };
};
exports.getMockTraderSettings = getMockTraderSettings;